module.exports = __webpack_public_path__ + "9952f45068b48a52f0381bc60a597fc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile19.png
// module id = 1879
// module chunks = 0